import { render } from "./Service.vue?vue&type=template&id=21d35fd4"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=21d35fd4&lang=scss"
script.render = render

export default script